/* eslint-disable react/button-has-type */
// TS-lint fail because of outdated version
import React, { useMemo } from 'react';
import { Icon } from '../Icon';
import { buttonCss } from './utils';
import './Button.scss';
export const Button = ({ text, onClick, theme = 'primary', size = 'medium', variant, overrideCss, className, customClass, iconAltText, iconSrc, disabled = false, type = 'button', }) => {
    const { baseButtonCss, baseButtonIcon, baseButtonText } = useMemo(() => buttonCss({
        className: className || customClass,
        overrideCss,
        size,
        theme,
        variant,
        disabled,
    }), [className, customClass, disabled, overrideCss, size, theme, variant]);
    const handleClick = () => {
        if (!disabled) {
            onClick();
        }
    };
    return (React.createElement("button", { className: baseButtonCss, onClick: handleClick, type: type, disabled: disabled },
        iconSrc && (React.createElement(Icon, { className: baseButtonIcon, source: iconSrc, svgStyle: { marginRight: '7px' }, altText: iconAltText })),
        text && React.createElement("span", { className: baseButtonText }, text)));
};
//# sourceMappingURL=Button.js.map